// From the Auth0 React Library
const CODE_RE = /[?&]code=[^&]+/
const STATE_RE = /[?&]state=[^&]+/
const ERROR_RE = /[?&]error=[^&]+/

export const hasLoginAuthParams = (
  searchParams = window.location.search
): boolean =>
  (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) &&
  STATE_RE.test(searchParams)

// TODO: Done in keycloak, but not in Auth0 or Cognito. We should use this in
// all vendors to reduce rerenders
export class AuthState {
  authorization: string = ''
  tokenExpiration: Date = new Date()
}
